import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '@mapfre-design-library/src/public_api';

@Injectable({
  providedIn: 'root',
})
export class ErrorRedirectionService {
  constructor(
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private alertService: AlertService
  ) {}

  redirect(where) {
    if (where && where.toString() != '500') {
      this.router.navigate(['/opps', where.toString()]);
    }
  }

  errorHandler(error, errorMsg) {
    if (
      error.status === 400 ||
      error.status === 403 ||
      error.status === 404 ||
      error.status === 408
    ) {
      this.alertService.error(errorMsg);
    } else if (error.status === 401) {
      if (this.activatedRoute.snapshot.url[0].path === 'login') {
        this.redirect(error.status);
      } else {
        this.alertService.error(errorMsg);
      }
    } else {
      this.redirect(error.status);
    }
  }
  errorRedirectHandler(error, poliycId?) {
    if (
      error &&
      error.status === 503 &&
      error.error &&
      error.error.Code === '965'
    ) {
      error.error.policyNumber = poliycId;
      this.router.navigate(['/service', 'message'], {
        state: { errInfo: error.error },
      });
    } else if (error.status) {
      this.redirect(error.status);
    }
  }
}
